// @noflow
import moment from 'moment-timezone';

export function injectGTMLoader(containerId) {
    if (process.env.PLATFORM === 'web') {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.innerText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
		var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
		j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})
		(window,document,'script','dataLayer','${containerId}');`;

        document.getElementsByTagName('head')[0].appendChild(s);
    }
}

export function isGTMActive(tag) {
    return tag && tag.get('active') && moment().isBetween(tag.get('start'), tag.get('end'));
}



// WEBPACK FOOTER //
// ./src/core/state/application/gtm.js